import React from 'react';

import { Box, Button, Stack, Typography } from '@mui/material';
import moment from 'moment';
import { TP_COLORS } from '../../../../../constants';
import { IUserAchievement } from '../../../../../store/UserSlice';
import {
  stackProps,
  editButtonStyles,
  deleteButtonStyles,
} from './ExperienceListItem';

interface AchievementListItemProps {
  achievementData: IUserAchievement;
  handleActions: (
    type: 'edit' | 'delete',
    achievementData: IUserAchievement
  ) => void;
}

const AchievementListItem: React.FC<AchievementListItemProps> = ({
  achievementData,
  handleActions,
}) => {
  const formattedDate = moment(achievementData.awardDate).format('YYYY-MM-DD');
  return (
    <Stack {...stackProps}>
      <Box display="flex" alignItems="center">
        <img
          src={`${process.env.PUBLIC_URL}/images/profile/icon-achievement.png`}
          alt="achievement-icon"
        />
        <Box marginLeft="17px">
          <Typography sx={{ color: TP_COLORS.gray.darken }}>
            {achievementData.awardTitle}
          </Typography>
          <Box display="flex" sx={{ color: '#94A3B8' }}>
            <Typography marginRight="20px" maxWidth="300px">
              {achievementData.awardBody}
            </Typography>
            <Typography>{formattedDate}</Typography>
          </Box>
        </Box>
      </Box>
      <Box>
        <Button
          sx={editButtonStyles}
          onClick={() => handleActions('edit', achievementData)}
        >
          Edit
        </Button>
        <Button
          sx={deleteButtonStyles}
          onClick={() => handleActions('delete', achievementData)}
        >
          Remove
        </Button>
      </Box>
    </Stack>
  );
};

export default AchievementListItem;
